module.exports = __webpack_public_path__ + "img/nft-subtitle.b6028b26.png";